import React from "react";

const TermsCondition = () => {
  return (
    <div className="container my-5">
      <div className="card shadow-sm border-0">
        <div className="card-body p-4">
          <h2 className="text-center mb-4 fw-bold">Terms and Conditions</h2>
          <p className="text-muted mb-4 text-center">
            Last updated: October 30, 2025
          </p>

          <h5 className="fw-semibold mt-4">1. Introduction</h5>
          <p>
            Welcome to <strong>Assit Buddi</strong>. By accessing or using our
            website, mobile app, or any of our services, you agree to comply
            with and be bound by the following terms and conditions. Please read
            them carefully before using our services.
          </p>

          <h5 className="fw-semibold mt-4">2. Use of Our Services</h5>
          <p>
            You agree to use our services only for lawful purposes and in a way
            that does not infringe the rights of, restrict, or inhibit anyone
            else’s use of the website or services. Any unauthorized use may give
            rise to a claim for damages or be a criminal offense.
          </p>

          <h5 className="fw-semibold mt-4">3. Account and Security</h5>
          <p>
            You are responsible for maintaining the confidentiality of your
            account and password and for restricting access to your account. You
            agree to accept responsibility for all activities that occur under
            your account.
          </p>

          <h5 className="fw-semibold mt-4">4. Intellectual Property</h5>
          <p>
            All content, design, graphics, and logos are the property of{" "}
            <strong>Your Company Name</strong> and are protected by applicable
            copyright and trademark laws. Unauthorized use of this material is
            prohibited.
          </p>

          <h5 className="fw-semibold mt-4">5. Limitation of Liability</h5>
          <p>
            We are not liable for any direct, indirect, incidental, or
            consequential damages arising from your use or inability to use our
            services, including but not limited to data loss, service
            interruption, or business loss.
          </p>

          <h5 className="fw-semibold mt-4">6. Changes to Terms</h5>
          <p>
            We reserve the right to update or modify these Terms and Conditions
            at any time without prior notice. Your continued use of our services
            constitutes your acceptance of any changes made.
          </p>

          <h5 className="fw-semibold mt-4">7. Contact Us</h5>
          <p>
            If you have any questions about these Terms and Conditions, please
            contact us at:
          </p>
          <ul>
            <li>Email: assitbuddi@foxaisr.com</li>
            <li>Phone: +91-XXXXXXXXXX</li>
            <li>Address: 238, Schem No. 114, Indore, MP, India</li>
          </ul>

          <p className="text-center mt-4 mb-0">
            <strong>Thank you for using our services!</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsCondition;
